import { COMPANY_NAME } from "../Application";

const Footer = () => {
   return (
      <footer>
         <span>{COMPANY_NAME}</span>
      </footer>
   );
};
export default Footer;